import { Suspense, lazy } from "react";
import Loading from "../components/loading/Loading";
import {ErrorBoundary} from "react-error-boundary";
import ErrorFallback from "../screens/errorScreen/ErrorFallback";

const LazyComponent = ({ path }) => {
  const LazyComponent = lazy(() => import(`../screens/${path}`));
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Suspense fallback={<Loading />}>
        <LazyComponent />
      </Suspense>
    </ErrorBoundary>
  );
};

export default LazyComponent;
